/*
 * create by nguyendx 2017/09/26
 */
import { NgModule } from "@angular/core";
import { RouterModule } from "@angular/router";
import { BrowserModule } from "@angular/platform-browser";
import { CommonModule } from "@angular/common";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import {
  ConfirmDialogModule,
  GrowlModule,
  TooltipModule,
} from "primeng/primeng";
import { HelperModule } from "../../../../common/helper/helper.module";
import { UploadService } from "../../../../common/services/Upload.service";
import { EvsProductListComponent } from "./product_list.component";
import { EvsProductAddComponent } from "./product_add.component";
import { EvsProductEditComponent } from "./product_edit.component";
import { ElabelConfigComponent } from "./elabel-config/elabel-config.component";
import { EvsProductViewComponent } from "./product_view.component";
import { EvsProductVariantComponent } from "./product_variant.component";
import { SelectModule } from "ng-select";
import { ToastrModule } from "ngx-toastr";
import { ModalModule } from "ngx-bootstrap/modal";
import { BsDatepickerModule } from "ngx-bootstrap";
import { SafeHtmlPipe } from "./safe-htm.pipe";
import { ImageService } from "../../../imageService";
import { TranslateModule } from "@ngx-translate/core";
import { FilterProductsModule } from "../../../../layout/filter-products/filter-products.module";
import { StampStatisticsService } from '../statistics/StampStatistics.service';

import { CKEditorModule } from "ng2-ckeditor";
import { EvsProductSettingComponent } from './product-setting/product_setting.component';
import { PointOfSaleComponent } from './product-setting/point_of_sale.component';
import { AddProductComponent } from './product-setting/add-product.component';
import { ProductStoreAddComponent } from '../product/product-store-add/product-store-add.component';
import { WarrantyReminderModule } from '../../../../common/components/warranty-reminder/warranty-reminder.module';


@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    ConfirmDialogModule,
    GrowlModule,
    TooltipModule,
    BrowserModule,
    HelperModule,
    SelectModule,
    ToastrModule.forRoot(),
    ModalModule.forRoot(),
    BsDatepickerModule.forRoot(),
    CKEditorModule,
    TranslateModule.forChild(),
    FilterProductsModule,
    WarrantyReminderModule,
  ],
  declarations: [
    EvsProductListComponent,
    EvsProductAddComponent,
    EvsProductEditComponent,
    ElabelConfigComponent,
    EvsProductSettingComponent,
    PointOfSaleComponent,
    EvsProductViewComponent,
    EvsProductVariantComponent,
    SafeHtmlPipe,
    AddProductComponent,
    ProductStoreAddComponent,
  ],
  exports: [
    EvsProductListComponent,
    EvsProductAddComponent,
    EvsProductEditComponent,
    EvsProductSettingComponent,
    PointOfSaleComponent,
    EvsProductViewComponent,
    EvsProductVariantComponent,
    AddProductComponent,
    ProductStoreAddComponent
  ],
  providers: [UploadService, ImageService, StampStatisticsService],
})
export class EvsProductsModule { }



// WEBPACK FOOTER //
// /app/src/app/pages/admin/evs/product/product.module.ts